import {
  createAddressArea as createAddressAreaApi, getAddressAreaByPin as getAddressAreaByPinApi, updateAddressArea as updateAddressAreaApi
  , updateAddressSubArea as updateAddressSubAreaApi
  , getUsedAddressArea as getUsedAddressAreaApi
} from "./SpatApi";
import { showErrorToast, showSuccessToast } from "../utils/Toasts";
import { getDataFromIndexDB, storeDataToIndexDB } from "../utils/dataStore";
const CACHE_KEY_getUsedAddressArea = "CACHE_getUsedAddressArea";


export async function handleCreateAddressArea(data) {
  try {
    const response = await createAddressAreaApi(data);
    if (response?.status === 201 || response?.status === 200) {
      showSuccessToast(response?.data?.message || "Address Area created successfully.");
      return true; // Return true on success
    } else {
      showErrorToast(response?.data?.message || response?.message || "Something went wrong while creating address Area");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Something went wrong.");
    return false;
  }
}

export async function fetchAddressAreaByPin(addressAreaPin, withSubAreasOnly) {
  try {
    //Check if there's a valid cached version
    if (withSubAreasOnly === 'true') {
      const response = await getDataFromIndexDB(CACHE_KEY_getUsedAddressArea + addressAreaPin);
      if (response) {
        const cachedData = JSON.parse(response);
        return cachedData;
      }
    }

    const response = await getAddressAreaByPinApi(addressAreaPin, withSubAreasOnly);
    if (response?.status === 201 || response?.status === 200) {
      await storeDataToIndexDB(CACHE_KEY_getUsedAddressArea + addressAreaPin, JSON.stringify(response.data), Number(process.env.REACT_APP_GENERAL_CACHE_EXPIRY_TIME));
      return response.data; // Return true on success
    } else {
      showErrorToast(response?.data?.message || response?.message || "Something went wrong while fetching address by PIN");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Something went wrong while fetching address by PIN");
    return false;
  }

}

export async function updateAddressArea(updatedAddressAreaData) {
  try {
    const response = await updateAddressAreaApi(updatedAddressAreaData);

    if (response?.status === 200 || response?.status === 201) {
      showSuccessToast("Address Area புதுப்பிக்கப்பட்டது");
      return true;  // Return true if the update was successful
    } else {
      showErrorToast(response?.data?.message || response?.message || "Error updating address Area");
      return false;  // Return false on failure
    }
  } catch (error) {
    showErrorToast("Error updating address Area");
    return false;  // Return false if an error occurs
  }
}

export async function updateAddressSubArea(updatedAddressSubAreaData) {
  try {
    const response = await updateAddressSubAreaApi(updatedAddressSubAreaData);

    if (response?.status === 200 || response?.status === 201) {
      showSuccessToast("Address sub Area புதுப்பிக்கப்பட்டது");
      return true;  // Return true if the update was successful
    } else {
      showErrorToast(response?.data?.message || response?.message || "Error updating address sub Area");
      return false;  // Return false on failure
    }
  } catch (error) {
    showErrorToast("Error updating address sub Area");
    return false;  // Return false if an error occurs
  }
}

export async function getUsedAddressArea() {
  try {
    const cachedResponse = await getDataFromIndexDB(CACHE_KEY_getUsedAddressArea + 'All');
    if (cachedResponse) {
      const cachedData = JSON.parse(cachedResponse);
      return cachedData;
    }
    const response = await getUsedAddressAreaApi();
    if (response?.status === 201 || response?.status === 200) {
      await storeDataToIndexDB(CACHE_KEY_getUsedAddressArea + 'All', JSON.stringify(response.data), Number(process.env.REACT_APP_GENERAL_CACHE_EXPIRY_TIME));
      return response.data;
    } else {
      showErrorToast(response?.data?.message || response?.message || "Something went wrong while querying used address");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Something went wrong during used address query.");
    return false;
  }
}